<template>
  <div id="app-container">
    <app-header> </app-header>
    <app-main> </app-main>
    <app-footer> </app-footer>
  </div>
</template>

<script>
import AppHeader from "./AppHeader";
import AppMain from "./AppMain";
import AppFooter from "./AppFooter";
export default {
  components: {
    AppHeader,
    AppMain,
    AppFooter
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppContainer.vue